import axios from "axios";

export const post = (endPoint, body, headers, encrypted, token) => {
    return axios.post(endPoint, body, {headers});
};
